'use strict';

module.exports = /* @ngInject */ function ($scope, $http, apiConfig, basketService, notificationService, translationService, uniteService) {
	$scope.loaded = false;
	$scope.serverError = false;
	$scope.serverErrorMessage = '';
	$scope.article = {};
	$scope.articleFeatures = [];

	$scope.supplierId = '';
	$scope.customerId = '';
	$scope.articleQuantity = 1;

	$scope.articleHistory = [];

	$scope.setArticleToMainArticle = setArticleToMainArticle;

	$scope.articleReferenceType = [
		"ACCESSORIES",
		"SIMILAR",
		"SPAREPART",
		"SELECT",
		"FOLLOWUP",
		"BASE_PRODUCT",
		"OTHERS"
	];

	$scope.options = {
		zoomEnable: true,
		defaultIndex: 0, // Order of the default selected Image
		images: [],
		style: 'inner', // inner or box
		boxPos: 'right-top', // e.g., right-top, right-middle, right-bottom, top-center, top-left, top-right ...
		boxW: 100, // Box widths
		boxH: 100, // Box height
		method: 'lens', // fallow 'lens' or 'pointer'
		cursor: 'none', // 'none', 'default', 'crosshair', 'pointer', 'move'
		lens: true, // Lens toggle
		zoomLevel: 2, // 0: not scales, uses the original large image size, use 1 and above to adjust.
		prevThumbButton: '&#9665;', // Prev thumb button (html)
		nextThumbButton: '&#9655;', // Next thumb button (html)
		thumbsPos: 'bottom', // Thumbs position: 'top', 'bottom'
		thumbCol: 3, // Thumb column count
		thumbColPadding: 4 // Padding between thumbs
	};

	$scope.selected = null;
	$scope.selectedIndex = null;

	// Processing fee
	$scope.processingFeeType = {
		absolute: 'ABSOLUTE',
		relative: 'RELATIVE',
		onRequest: 'ON_REQUEST'
	};

	$scope.processingFeeTranslation = {
		ABSOLUTE: translationService.translate(_('Festpreis')),
		RELATIVE: translationService.translate(_('Relativ zum Lieferpreis')),
		ON_REQUEST: translationService.translate(_('auf Anfrage')),
	};

	// Return policy
	$scope.shippingCostPayerTranslation = {
		CUSTOMER: translationService.translate(_('Kunde')),
		SUPPLIER: translationService.translate(_('Lieferant')),
	};

	$scope.stateOfPackagingTranslation = {
		UNOPENED: translationService.translate(_('Die Retoure wird nur akzeptiert, wenn sich das Produkt im Originalpaket befindet und ungeöffnet ist.')),
		OPENED_ORIGINAL_PACKAGING_OK: translationService.translate(_('Die Retoure wird nur akzeptiert, wenn das Originalpaket intakt ist, unabhängig davon ob es geöffnet wurde.')),
		ORIGINAL_PACKAGING_DAMAGED: translationService.translate(_('Die Retoure wird nur akzeptiert, wenn sich das Produkt im Originalpaket befindet, selbst wenn das Paket beschädigt ist.')),
		NO_ORIGINAL_PACKAGING: translationService.translate(_('Die Retoure wird akzeptiert, unabhängig davon ob sich das Produkt im Originalpaket befindet.'))
	};

	$scope.stateOfProductTranslation = {
		UNUSED: translationService.translate(_('Die Retoure wird nur akzeptiert, wenn das Produkt unbenutzt ist.')),
		USED: translationService.translate(_('Die Retoure wird nur akzeptiert, wenn das Produkt intakt ist, unabhängig, ob es benutzt wurde.')),
		BROKEN: translationService.translate(_('Die Retoure eines beschädigten Produktes wird akzeptiert')),
	};

	$scope.returnPolicyAdditionalTexts = '';

	$scope.init = init;

	function init(articleId, supplier, customer) {
		$scope.loadData(articleId, supplier, customer);
	}

	$scope.checkQuantity = uniteService.checkUniteArticleQuantity;

	/**
	 * load unite search result from api
	 */
	$scope.loadData = function (articleId, supplier, customer) {
		$scope.supplierId = supplier;
		$scope.customerId = customer;

		uniteService.getArticleById.get({
			articleId: articleId,
			supplier: supplier,
			customer: customer
		}).$promise.then(function (result) {
			$scope.article = result;
			$scope.articleQuantity = $scope.article.orderDetails.minimumOrderQuantity;
			var currentLanguage = translationService.getCurrentLocale() !== '' ? translationService.getCurrentLocale() : 'de_DE';
			if($scope.article.returnPolicy.additionalTexts !== null){
				$scope.article.returnPolicy.additionalTexts.forEach(function(text){
					if(currentLanguage.indexOf(text.lang) <= 0){
						$scope.returnPolicyAdditionalTexts = text.value;
					}
				});
			}
			result.articleFeatures
				.filter(function (feature) {
					return feature.features !== null && feature.features.length > 0
				})
				.forEach(function (feature) {
					feature.features.forEach(function (f) {
						$scope.articleFeatures.push(f);
					})
				});
			for (let image of result.mimeInfos) {
				$scope.options.images.push({
					thumb: image.href[0].value,
					medium: image.href[0].value,
					large: image.href[0].value
				})
			}
			$scope.loaded = true;
		}, showError);
	};

	function showError(error) {
		$scope.serverError = true;
		$scope.serverErrorMessage = '' + error.data.message + '<br>' + error.data.exception;
	}

	/**
	 * adds one or more items to the basket
	 * @param basketId
	 * @param articleQuantity
	 * @param companyCodeId
	 * @param companyCode
	 */
	$scope.addToBasket = function (basketId, articleQuantity, companyCodeId, companyCode) {
		basketService.addUniteArticle.get(
			{
				articleId: $scope.article.id,
				articleQuantity: articleQuantity,
				basketId: basketId,
				customerId: $scope.customerId,
				supplierCompanyId: $scope.supplierId,
				companyCodeId: companyCodeId,
				companyCode: companyCode
			}
		).$promise.then(function () {
			miniBasketRefresh();
			closePopup();
			notificationService.showSuccessNotification(
				articleQuantity + ' ' + translationService.translate(_('Artikel wurde in den Warenkorb gelegt!')),
				5000);
		}, function (error) {
			notificationService.showErrorNotification(
				translationService.translate(_('Artikel konnte nicht in den Warenkorb gelegt werden.')), 5000);
		});
	};

	/**
	 * loads the article which was displayed before the current article
	 */
	$scope.goBackInHistory = function () {
		if ($scope.articleHistory.length > 0) {
			var lastHistoryItem = $scope.articleHistory.pop();
			setArticleToMainArticle(lastHistoryItem, true);
		}
	};

	/**
	 * sets a new article as main article
	 * @param newArticle
	 * @param isHistoryArticle
	 */
	function setArticleToMainArticle(newArticle, isHistoryArticle) {
		if (newArticle) {
			// don't push to history when the new article is a history article
			if (!isHistoryArticle) {
				$scope.articleHistory.push($scope.article);
			}
			$scope.loaded = false;
			$scope.serverError = false;
			$scope.serverErrorMessage = '';
			$scope.article = {};
			$scope.articleFeatures = [];
			$scope.articleQuantity = 1;
			$scope.references = {
				accessories: {
					data: [],
					display: []
				}
			};
			init(newArticle.id, $scope.supplierId, $scope.customerId);
		}
	}

}
